"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
let mode = "interactive";
const hideTag = process.env.PLATFORM === "ds" ? "hide_on_ds" : "hide_on_app";
const getBubbleFilters = (venue) => venue.interests.map(({ group }) => ({
    id: group.id,
    name: group.name,
    interests: group.interests.map((interest) => interest.id),
    iconUrl: group.iconUrl,
}));
const getUserSelectedInterests = (venue) => venue.interests.map(({ group }) => ({
    id: group.id,
    name: group.name,
    interests: group.interests.map((interest) => interest.id),
    selected: true,
}));
const filterCollectionByQueryInterests = (collection, interests, venue) => {
    const queryInterests = Array.isArray(interests) ? interests : [interests];
    const venueInterests = getBubbleFilters(venue);
    const interestsToFilterBy = [];
    queryInterests.map((interest) => {
        const queryInterest = parseInt(interest, 10);
        const interestGroup = venueInterests.find((venueInterest) => venueInterest.id === queryInterest);
        if (interestGroup) {
            interestsToFilterBy.push(...interestGroup.interests);
        }
        else {
            interestsToFilterBy.push(queryInterest);
        }
        return interest;
    });
    return collection.filter((item) => item.interestIds.filter((interestId) => interestsToFilterBy.indexOf(interestId) !== -1).length > 0);
};
const filterCollectionByQueryTags = (collection, tags) => {
    const tagsArray = Array.isArray(tags) ? tags : [tags];
    return collection.filter((item) => item.tags.filter((tag) => tagsArray.indexOf(tag) !== -1).length > 0);
};
const filterCollectionByQueryParams = (collection, queryParams, venue) => {
    if (Array.isArray(queryParams.mode)) {
        mode = queryParams.mode[0]; // Use the first mode if it's an array
    }
    else {
        mode = queryParams.mode; // Directly use the mode if it's a string
    }
    if (!queryParams.tag && !queryParams.interest) {
        return collection;
    }
    const filteredCollection = [];
    if (queryParams.tag) {
        filteredCollection.push(...filterCollectionByQueryTags(collection, queryParams.tag));
    }
    if (queryParams.interest) {
        filteredCollection.push(...filterCollectionByQueryInterests(collection, queryParams.interest, venue));
    }
    return Array.from(new Set(filteredCollection));
};
const filterActivitiesByBackofficeTags = (activities) => {
    const backofficeTags = mode === "interactive"
        ? ["hide_on_giant_tablet", "hide_on_active_ds"]
        : ["hide_on_tv", "hide_on_passive_ds"];
    return activities.filter((activity) => {
        if (activity.tags.indexOf(hideTag) !== -1) {
            return false;
        }
        return (activity.tags.filter((tag) => backofficeTags.indexOf(tag) !== -1).length <
            1);
    });
};
const flattenTreeStructure = (treeStructure) => {
    const flattenedStructure = [];
    const flatten = (structure) => {
        structure.map((node) => {
            const nodeType = Object.keys(node)[0];
            if (nodeType === "folder") {
                flatten(node[nodeType].children);
            }
            else {
                flattenedStructure.push(node[nodeType]);
            }
            return node;
        });
    };
    flatten(treeStructure);
    return flattenedStructure;
};
const filterOffersAndDirectoriesByBackofficeTags = (collection, queryParams) => {
    let queryTags = [];
    if (queryParams.tag) {
        queryTags = Array.isArray(queryParams.tag)
            ? queryParams.tag
            : [queryParams.tag];
    }
    const backofficeTags = mode === "interactive"
        ? ["screensaver_on_active", "screensaver_on_giant_tablet"]
        : ["screensaver_on_passive", "screensaver_on_tv"];
    return collection.filter((item) => {
        if (item.type === "website" || item.tags.indexOf(hideTag) !== -1) {
            return false;
        }
        if (queryTags.length > 0 &&
            item.tags.filter((tag) => queryTags.indexOf(tag) !== -1).length > 0) {
            return true;
        }
        return (item.tags.filter((tag) => backofficeTags.indexOf(tag) !== -1).length > 0);
    });
};
const filterHiddenContentInTreeStructure = (nodes) => {
    const filteredNodes = nodes.filter((node) => {
        const nodeType = Object.keys(node)[0];
        const currentNode = node[nodeType];
        if (currentNode.tags.indexOf(hideTag) !== -1) {
            return false;
        }
        if (nodeType === "folder") {
            return Object.assign(currentNode, {
                children: filterHiddenContentInTreeStructure(currentNode.children),
            });
        }
        return true;
    });
    return filteredNodes;
};
const filterExclusiveSlides = (slides) => slides.filter((slide) => slide.dsExclusive);
const filterFullScreenSlides = (slides) => slides.filter((slide) => slide.dsFullScreen);
exports.default = {
    getBubbleFilters,
    getUserSelectedInterests,
    filterCollectionByQueryParams,
    filterActivitiesByBackofficeTags,
    flattenTreeStructure,
    filterHiddenContentInTreeStructure,
    filterOffersAndDirectoriesByBackofficeTags,
    filterExclusiveSlides,
    filterFullScreenSlides,
};
